import React from "react";
import {
  Organization,
  Partners,
  Diamond,
  Magnet,
  People,
  Contracts
} from "@dreamhub/designsystem/icons";
import { GlobalSearchEntityTypes } from "../types";
import {
  entityTypeToSingleEntityName,
  EntityType
} from "@/services/hooks/entities/useEntityType";

export const entityIcons = {
  [GlobalSearchEntityTypes.COMPANIES]: Organization,
  [GlobalSearchEntityTypes.PARTNERS]: Partners,
  [GlobalSearchEntityTypes.DEALS]: Diamond,
  [GlobalSearchEntityTypes.LEADS]: Magnet,
  [GlobalSearchEntityTypes.PEOPLE]: People,
  // Partner contacts render in the People tab/section — same icon as people.
  [GlobalSearchEntityTypes.PARTNERS_CONTACTS]: People,
  [GlobalSearchEntityTypes.CONTRACTS]: Contracts
} as const;

export type EntityIconType = (typeof entityIcons)[keyof typeof entityIcons];

export const getEntityIcon = (
  entityType?: GlobalSearchEntityTypes
): React.ReactElement | null => {
  if (!entityType) return null;

  const IconComponent = entityIcons[entityType];
  return IconComponent ? <IconComponent /> : null;
};

const globalSearchToEntityTypeMap = {
  [GlobalSearchEntityTypes.COMPANIES]: EntityType.COMPANY,
  [GlobalSearchEntityTypes.PARTNERS]: EntityType.PARTNER,
  [GlobalSearchEntityTypes.DEALS]: EntityType.DEAL,
  [GlobalSearchEntityTypes.LEADS]: EntityType.LEAD,
  [GlobalSearchEntityTypes.PEOPLE]: EntityType.PERSON,
  [GlobalSearchEntityTypes.PARTNERS_CONTACTS]: EntityType.PARTNER_CONTACT,
  [GlobalSearchEntityTypes.CONTRACTS]: EntityType.CONTRACT
} as const;

export const getEntityTypeLabel = (
  entityType?: GlobalSearchEntityTypes
): string => {
  if (!entityType) return "";

  const mappedEntityType = globalSearchToEntityTypeMap[entityType];
  if (!mappedEntityType) return "";

  const singleEntityName = entityTypeToSingleEntityName[mappedEntityType];
  return singleEntityName.charAt(0).toUpperCase() + singleEntityName.slice(1);
};
